// extracted by mini-css-extract-plugin
module.exports = {"container":"listInfo_container__DY6xw","section-title":"listInfo_section-title__25C-l","info-list":"listInfo_info-list__15_Rb"};